// extracted by css-extract-rspack-plugin
export default {"wrapper":"_304a2acf","contentWrapper":"_163126a6","inputWrapper":"_1621cab9","iconWrapper":"_ef04ed84"};